import { createAsyncThunk } from '@reduxjs/toolkit';

import { HadesehApiPath } from 'Feature/Hadeseh/Common/Constant/HadesehApiPath';
import { HavadesEnferadiHttpGetService } from 'Feature/Hadeseh/Common/Services/HavadesEnferadiHttpServices';

export const printElhaghiyehHadesehEnferadi = createAsyncThunk(
  'HadesehEnferadi/printElhaghiyehHadesehEnferadi',
  async (query: any) => {
    return await HavadesEnferadiHttpGetService({
      url: `${HadesehApiPath.BimehNamehHadesehEnferadi.PrintElhaghiyehHadesehEnferadi}`,
      params: query,
      responseType: 'blob',
      isFile: true,
    });
  }
);

export const getElhaghiyehHayeSadereh = createAsyncThunk('HadesehEnferadi/getElhaghiyehHayeSadereh', async () => {
  return await HavadesEnferadiHttpGetService({
    url: `${HadesehApiPath.BimehNamehHadesehEnferadi.GetElhaghiyehHayeSadereh}`,
  });
});
